import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take, finalize } from 'rxjs/operators';

import { FlashService } from '../flash/services/flash.service';
import { SegmentService } from 'app/segments/services/segment.service';
import { parseCsv, stringifyCsv } from 'app/shared/utils/csv-to-array';

const TEMPLATE_HEADER = [ 'consumer_id', 'slug' ];
const TEMPLATE_ROWS = [
  TEMPLATE_HEADER,
  [ 'c_8f2a41d0', 'vip' ],
  [ 'c_1b93e7aa', 'promo_ete' ],
  [ 'c_44c0f2be', 'reactivation' ],
];
const TEMPLATE_FILENAME = 'modele-import-segments.csv';

@Component({
  selector: 'app-dialog-import-segments',
  templateUrl: './dialog-import-segments.component.html',
  styleUrls: ['./dialog-import-segments.component.sass']
})
export class DialogImportSegmentsComponent implements OnInit {
  selectedFile: any = {};
  csvErrors = [];
  missingHeader = false;
  uploading = false;
  templateRows = TEMPLATE_ROWS;
  templateExamples = TEMPLATE_ROWS.slice(1);

  constructor(
    public dialogRef: MatDialogRef<DialogImportSegmentsComponent>,
    public segmentService: SegmentService,
    private flashService: FlashService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onCsvFileSelected(uploaded) {
    this.csvErrors = [];

    const lines = parseCsv(uploaded.file.content);
    const hasHeader = this.isHeaderLine(lines[0]);
    const dataLines = hasHeader ? lines.slice(1) : lines;

    this.missingHeader = !hasHeader;

    dataLines.forEach((line, i) => {
      if (
        (
          line.length > 2
          ||
          !(line[0] || '').trim()
        )
      ) {
        return this.csvErrors.push({
          line: i + 1 + (hasHeader ? 1 : 0),
          content: line.join(';'),
        });
      }
    });

    if (!this.csvErrors.length) {
      this.upload(uploaded);
    }
  }

  onDownloadTemplateClick() {
    const csv = stringifyCsv(this.templateRows);
    const blob = new Blob([ csv ], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = TEMPLATE_FILENAME;
    link.click();
  }

  onStartAgain() {
    this.csvErrors = [];
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  upload(file) {
    this.uploading = true;

    this.segmentService.upload(file.raw)
      .pipe(
        take(1),
        finalize(() => {
          this.uploading = false;
        })
      )
      .subscribe(
        (response) => {
          if (!this.csvErrors.length) {
            if (this.missingHeader) {
              this.flashService.important('segments.dialog.import.header.warning');
            }
            this.flashService.success('segments.dialog.import.form.success');
            this.dialogRef.close(true);
          }
        },
        (error) => {
          alert('Import error ' + error.status);
        }
    );
  }

  private isHeaderLine(line: string[] = []): boolean {
    return (line[0] || '').trim().toLowerCase() === TEMPLATE_HEADER[0]
      && (line[1] || '').trim().toLowerCase() === TEMPLATE_HEADER[1];
  }
}
